import React, { useEffect, useRef, useState } from "react";
import { Button, Card, Descriptions, Divider, Typography, Tag, Progress } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import ScormAPI from "../apis/ScromAPI";


const { Title, Text } = Typography;
const ScormPlayer = (props) => {
  const navigate = useNavigate();
  const [scorm_data, set_scorm_data] = useState(props?.scorm_data || null);
  const iframeRef = useRef(null);
  const apiRef = useRef(null);
  const [iframeReady, setIframeReady] = useState(false);

  useEffect(() => {
    const api = new ScormAPI(
      props.course_id,
      props.launchFile,
      props.scorm_version || "1.2",
      (data) => {
        set_scorm_data(data);   //  LIVE UPDATE
      },     
      props?.scorm_data?.resume_data || null    // RESUME DATA
    );
    apiRef.current = api;


    // SCORM 1.2

    const api12 = { 
      LMSInitialize: api.LMSInitialize.bind(api),
      LMSFinish: api.LMSFinish.bind(api),
      LMSGetValue: api.LMSGetValue.bind(api),
      LMSSetValue: api.LMSSetValue.bind(api),
      LMSCommit: api.LMSCommit.bind(api),
      LMSGetLastError: api.LMSGetLastError.bind(api),
      LMSGetErrorString: api.LMSGetErrorString.bind(api),
      LMSGetDiagnostic: api.LMSGetDiagnostic.bind(api),
    };


    // SCORM 2004

    const api2004 = {
      Initialize: api.LMSInitialize.bind(api),
      Terminate: api.LMSFinish.bind(api),
      GetValue: api.LMSGetValue.bind(api),
      SetValue: api.LMSSetValue.bind(api),
      Commit: api.LMSCommit.bind(api),
      GetLastError: api.LMSGetLastError.bind(api),
      GetErrorString: api.LMSGetErrorString.bind(api),
      GetDiagnostic: api.LMSGetDiagnostic.bind(api),
    };


    // GLOBAL API

    window.API = api12;
    window.API_1484_11 = api2004;

    document.API = api12;
    document.API_1484_11 = api2004;

    try {
      window.parent.API = api12;
      window.parent.API_1484_11 = api2004;

      window.top.API = api12;
      window.top.API_1484_11 = api2004;
    } catch (e) {
      console.log(e);
    }


    // IFRAME LOAD DELAY
    setTimeout(() => {
      setIframeReady(true);
    }, 500);


    // AUTO SAVE

    const interval = setInterval(() => {
      try {
        api.LMSCommit("");
      } catch (e) {
        console.log(e);
      }
    }, 10000);


    // WINDOW CLOSE

    const handleUnload = () => {
      try {
        api.LMSCommit("");
        api.LMSFinish("");
      } catch (e) {
        console.log(e);
      }
    };

    window.addEventListener("beforeunload", handleUnload);

    return () => {
      clearInterval(interval);

      if (api.storylineInterval) {
        clearInterval(api.storylineInterval);
      }

      window.removeEventListener("beforeunload", handleUnload);

      try {
        api.LMSCommit("");
        api.LMSFinish("");
      } catch (e) { }

      delete window.API;
      delete window.API_1484_11;
    };
  }, []);


  // IFRAME LOAD

  const handleIframeLoad = () => {
    try {
      const iframeWindow = iframeRef.current.contentWindow;

      iframeWindow.API = window.API;
      iframeWindow.API_1484_11 = window.API_1484_11;

      console.log("API injected into iframe");

      if (apiRef.current) {
        apiRef.current.startStorylineTracking(iframeWindow);
      }
    } catch (e) {
      console.log("Iframe API injection failed", e);
    }
  };
  console.log("Scorm data", scorm_data);
  return (
    <div
      style={{
        width: "100%",
        margin: "10px auto",
        padding: "5px",
      }}
    >
      <Button
        type="default"
        icon={<ArrowLeftOutlined />}
        onClick={() => navigate(-1)}
        style={{
          marginBottom: "10px",
          borderRadius: "8px",
        }}
      >
        Go Back
      </Button>

      <Card
        style={{
          borderRadius: "12px",
          boxShadow: "0 8px 24px rgba(0,0,0,0.15)",
          overflow: "hidden",
        }}
      >
        {iframeReady && (
          <>
            <iframe
              ref={iframeRef}
              src={props?.launchFile}
              onLoad={handleIframeLoad}
              width="100%"
              height="700px"
              allowFullScreen
              title="SCORM Player"
              style={{
                border: "none",
                borderRadius: "12px",
              }}
            />
            <div style={{ marginTop: 8 }}>
              <Progress percent={scorm_data?.progress_percentage || 0} status="active" />
            </div>
            {/* ================= COURSE INFO ================= */}
            <div style={{ padding: "16px 20px" }}>
              <Divider orientation="left">
                <Title level={5} style={{ margin: 0 }}>
                  Course Information
                </Title>
              </Divider>

              <Descriptions
                bordered
                size="middle"
                column={2}
                labelStyle={{ fontWeight: 600, width: 180 }}
              >
                <Descriptions.Item label="Course Title">
                  <Text strong>{props?.course_title || "-"}</Text>
                </Descriptions.Item>

                <Descriptions.Item label="Course Status">
                  <Tag color="green">
                    {scorm_data?.success_status || "Incomplete"}
                  </Tag>
                </Descriptions.Item>

                <Descriptions.Item label="Progress Percentage">
                  <Tag color="green">
                    {scorm_data?.progress_percentage}
                  </Tag>
                </Descriptions.Item>

              </Descriptions>
            </div>
          </>
        )}

        <Card.Meta
          title={
            <span
              style={{
                fontSize: "20px",
                color: "#1ac1cb",
              }}
            >
              {props.course_title}
            </span>
          }
        />
      </Card>
    </div>
  );
};

export default ScormPlayer;